const front_end = [
  {
    name: 'React',
    imgUrl: '/technologies/react.png'
  },
  {
    name: 'Redux',
    imgUrl: '/technologies/redux.png'
  },
  {
    name: 'Next.js',
    imgUrl: '/technologies/next.svg'
  },
  {
    name: 'Vue.js',
    imgUrl: '/technologies/vue.svg'
  },
  {
    name: 'Pinia',
    imgUrl: '/technologies/pinia.svg'
  },
  {
    name: 'Three Js',
    imgUrl: '/technologies/threejs.svg'
  },
  {
    name: 'Tailwind',
    imgUrl: '/technologies/tailwind.svg'
  },
  {
    name: 'Webpack',
    imgUrl: '/technologies/webpack.svg'
  },
  {
    name: 'Framer Motion',
    imgUrl: '/technologies/framer_motion.svg'
  },
  {
    name: 'Sass',
    imgUrl: '/technologies/sass.svg'
  }
];

export default front_end;
